import { IApplicationState } from '../types/redux';

export function selectContactsAccessOfferId(state: IApplicationState): number | null {
  return state.earlyAccessContacts.offerId;
}
